/* eslint-disable */
import { useState, useEffect, useRef, useCallback } from "react";
import { C } from "../shared/globals.js";

const FM = "Montserrat,sans-serif";

// ── Top 50 S&P 500 stocks ────────────────────────────────────────────────────
const TOP50_STOCKS = [
  { ticker:"AAPL",  name:"Apple",              domain:"apple.com" },
  { ticker:"MSFT",  name:"Microsoft",           domain:"microsoft.com" },
  { ticker:"NVDA",  name:"NVIDIA",              domain:"nvidia.com" },
  { ticker:"AMZN",  name:"Amazon",              domain:"amazon.com" },
  { ticker:"GOOGL", name:"Alphabet",            domain:"abc.xyz" },
  { ticker:"META",  name:"Meta Platforms",      domain:"meta.com" },
  { ticker:"TSLA",  name:"Tesla",               domain:"tesla.com" },
  { ticker:"BRK-B", name:"Berkshire Hathaway",  domain:"berkshirehathaway.com" },
  { ticker:"LLY",   name:"Eli Lilly",           domain:"lilly.com" },
  { ticker:"JPM",   name:"JPMorgan Chase",      domain:"jpmorganchase.com" },
  { ticker:"V",     name:"Visa",                domain:"visa.com" },
  { ticker:"UNH",   name:"UnitedHealth",        domain:"unitedhealthgroup.com" },
  { ticker:"XOM",   name:"ExxonMobil",          domain:"exxonmobil.com" },
  { ticker:"MA",    name:"Mastercard",           domain:"mastercard.com" },
  { ticker:"JNJ",   name:"Johnson & Johnson",   domain:"jnj.com" },
  { ticker:"AVGO",  name:"Broadcom",            domain:"broadcom.com" },
  { ticker:"PG",    name:"Procter & Gamble",    domain:"pg.com" },
  { ticker:"HD",    name:"Home Depot",           domain:"homedepot.com" },
  { ticker:"COST",  name:"Costco",              domain:"costco.com" },
  { ticker:"MRK",   name:"Merck",               domain:"merck.com" },
  { ticker:"CVX",   name:"Chevron",             domain:"chevron.com" },
  { ticker:"ABBV",  name:"AbbVie",              domain:"abbvie.com" },
  { ticker:"KO",    name:"Coca-Cola",           domain:"coca-cola.com" },
  { ticker:"PEP",   name:"PepsiCo",             domain:"pepsico.com" },
  { ticker:"ADBE",  name:"Adobe",              domain:"adobe.com" },
  { ticker:"WMT",   name:"Walmart",             domain:"walmart.com" },
  { ticker:"BAC",   name:"Bank of America",     domain:"bankofamerica.com" },
  { ticker:"CRM",   name:"Salesforce",          domain:"salesforce.com" },
  { ticker:"MCD",   name:"McDonald's",          domain:"mcdonalds.com" },
  { ticker:"TMO",   name:"Thermo Fisher",       domain:"thermofisher.com" },
  { ticker:"ORCL",  name:"Oracle",              domain:"oracle.com" },
  { ticker:"ACN",   name:"Accenture",           domain:"accenture.com" },
  { ticker:"CSCO",  name:"Cisco",               domain:"cisco.com" },
  { ticker:"ABT",   name:"Abbott",              domain:"abbott.com" },
  { ticker:"AMD",   name:"AMD",                 domain:"amd.com" },
  { ticker:"NFLX",  name:"Netflix",             domain:"netflix.com" },
  { ticker:"DIS",   name:"Walt Disney",         domain:"thewaltdisneycompany.com" },
  { ticker:"DHR",   name:"Danaher",             domain:"danaher.com" },
  { ticker:"INTC",  name:"Intel",               domain:"intel.com" },
  { ticker:"WFC",   name:"Wells Fargo",         domain:"wellsfargo.com" },
  { ticker:"VZ",    name:"Verizon",             domain:"verizon.com" },
  { ticker:"PM",    name:"Philip Morris",       domain:"pmi.com" },
  { ticker:"TXN",   name:"Texas Instruments",  domain:"ti.com" },
  { ticker:"UPS",   name:"UPS",                 domain:"ups.com" },
  { ticker:"NEE",   name:"NextEra Energy",      domain:"nexteraenergy.com" },
  { ticker:"RTX",   name:"RTX Corp",            domain:"rtx.com" },
  { ticker:"BMY",   name:"Bristol-Myers",       domain:"bms.com" },
  { ticker:"AMGN",  name:"Amgen",               domain:"amgen.com" },
  { ticker:"QCOM",  name:"Qualcomm",            domain:"qualcomm.com" },
  { ticker:"HON",   name:"Honeywell",           domain:"honeywell.com" },
];

// ── Formatters ───────────────────────────────────────────────────────────────
const fmtPrice = v => {
  if (!v && v !== 0) return "—";
  if (v < 0.01)  return "$" + v.toFixed(4);
  if (v < 1)     return "$" + v.toFixed(3);
  if (v < 1000)  return "$" + v.toFixed(2);
  return "$" + v.toLocaleString("en-US", { minimumFractionDigits:2, maximumFractionDigits:2 });
};
const fmtLarge = v => {
  if (!v) return "—";
  if (v >= 1e12) return "$" + (v/1e12).toFixed(2) + "T";
  if (v >= 1e9)  return "$" + (v/1e9).toFixed(2) + "B";
  if (v >= 1e6)  return "$" + (v/1e6).toFixed(2) + "M";
  return "$" + v.toLocaleString("en-US", { maximumFractionDigits:0 });
};
const fmtSupply = (v, sym) => {
  if (!v) return "—";
  if (v >= 1e12) return (v/1e12).toFixed(2) + "T " + sym;
  if (v >= 1e9)  return (v/1e9).toFixed(2) + "B " + sym;
  if (v >= 1e6)  return (v/1e6).toFixed(2) + "M " + sym;
  return v.toLocaleString("en-US",{maximumFractionDigits:0}) + " " + sym;
};

const PctCell = ({ v }) => {
  if (v == null) return <span style={{ color:"var(--text5)" }}>—</span>;
  const up = v >= 0;
  return <span style={{ fontFamily:FM, fontSize:12, fontWeight:700, color: up ? C.green : C.red }}>{up?"▲":"▼"} {Math.abs(v).toFixed(2)}%</span>;
};

const Sparkline = ({ data, positive }) => {
  if (!data || data.length < 2) return null;
  const W = 80, H = 28;
  const min = Math.min(...data), max = Math.max(...data);
  const range = max - min || 1;
  const pts = data.map((v,i) => `${(i/(data.length-1))*W},${H-((v-min)/range)*H}`).join(" ");
  return (
    <svg width={W} height={H} style={{ display:"block" }}>
      <polyline points={pts} fill="none" stroke={positive ? C.green : C.red}
        strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" opacity="0.9"/>
    </svg>
  );
};

// ── Main component ────────────────────────────────────────────────────────────
export default function CryptoMarketsPage({ isMobile = false, onSelectTicker }) {
  const [mode,       setMode]       = useState("crypto"); // "crypto" | "stocks"
  const [coins,      setCoins]      = useState([]);
  const [stocks,     setStocks]     = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState(null);
  const [sortKey,    setSortKey]    = useState("rank");
  const [sortDir,    setSortDir]    = useState("asc");
  const [search,     setSearch]     = useState("");
  const [lastUpdate, setLastUpdate] = useState(null);
  const intervalRef  = useRef(null);

  // ── Fetch crypto ──────────────────────────────────────────────────────────
  const fetchCrypto = async () => {
    try {
      const res = await fetch(
        "https://api.coingecko.com/api/v3/coins/markets" +
        "?vs_currency=usd&order=market_cap_desc&per_page=50&page=1" +
        "&sparkline=true&price_change_percentage=1h,24h,7d",
        { headers: { "Accept":"application/json" } }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setCoins(data.map((c,i) => ({
        rank:       c.market_cap_rank || i+1,
        id:         c.id,
        name:       c.name,
        symbol:     c.symbol.toUpperCase(),
        logo:       c.image,
        price:      c.current_price,
        pct1h:      c.price_change_percentage_1h_in_currency,
        pct24h:     c.price_change_percentage_24h,
        pct7d:      c.price_change_percentage_7d_in_currency,
        marketCap:  c.market_cap,
        volume:     c.total_volume,
        supply:     c.circulating_supply,
        maxSupply:  c.max_supply,
        spark:      c.sparkline_in_7d?.price,
      })));
      setLastUpdate(new Date());
      setError(null);
    } catch(e) { setError("Crypto fetch failed: " + e.message); }
    finally { setLoading(false); }
  };

  // ── Fetch stocks via /api/mstr-price ─────────────────────────────────────
  const fetchStocks = async () => {
    setLoading(true);
    try {
      const results = await Promise.all(
        TOP50_STOCKS.map(async (s, i) => {
          try {
            const res = await fetch(`/api/mstr-price?ticker=${encodeURIComponent(s.ticker)}&t=${Date.now()}`);
            if (!res.ok) return null;
            const d = await res.json();
            const price    = d.price   || 0;
            const prev     = d.prev    || 0;
            const pct24h   = prev > 0 ? ((price - prev) / prev) * 100 : null;
            return {
              rank:      i + 1,
              id:        s.ticker,
              name:      s.name,
              symbol:    s.ticker,
              logo:      `https://logo.clearbit.com/${s.domain}`,
              domain:    s.domain,
              price,
              prev,
              pct1h:     null,
              pct24h,
              pct7d:     null,
              marketCap: d.marketCap || null,
              volume:    d.volume    || null,
              supply:    d.shares    || null,
              maxSupply: null,
              spark:     null,
            };
          } catch { return null; }
        })
      );
      setStocks(results.filter(Boolean));
      setLastUpdate(new Date());
      setError(null);
    } catch(e) { setError("Stocks fetch failed: " + e.message); }
    finally { setLoading(false); }
  };

  // Switch mode — fetch on change
  useEffect(() => {
    clearInterval(intervalRef.current);
    setLoading(true);
    setError(null);
    setSortKey("rank");
    setSortDir("asc");
    setSearch("");
    if (mode === "crypto") {
      fetchCrypto();
      intervalRef.current = setInterval(fetchCrypto, 60000);
    } else {
      fetchStocks();
      intervalRef.current = setInterval(fetchStocks, 120000);
    }
    return () => clearInterval(intervalRef.current);
  }, [mode]);

  const activeData = mode === "crypto" ? coins : stocks;

  const handleSort = key => {
    if (sortKey === key) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortKey(key); setSortDir(key === "rank" ? "asc" : "desc"); }
  };

  const sortVal = row => {
    const map = { rank:"rank", price:"price", pct1h:"pct1h", pct24h:"pct24h", pct7d:"pct7d", marketCap:"marketCap", volume:"volume" };
    return row[map[sortKey]] ?? (sortDir==="asc"?Infinity:-Infinity);
  };

  const filtered = activeData
    .filter(c => !search || c.name.toLowerCase().includes(search.toLowerCase()) || c.symbol.toLowerCase().includes(search.toLowerCase()))
    .sort((a,b) => sortDir==="asc" ? sortVal(a)-sortVal(b) : sortVal(b)-sortVal(a));

  const SortIcon = ({ k }) => {
    if (sortKey !== k) return <span style={{ opacity:0.3, fontSize:8 }}>⇅</span>;
    return <span style={{ fontSize:9, color:C.orange }}>{sortDir==="asc"?"▲":"▼"}</span>;
  };

  const thStyle = (k, align="right") => ({
    fontFamily:FM, fontSize:9, fontWeight:700, letterSpacing:"0.15em",
    color: sortKey===k ? C.orange : "var(--text4)",
    textAlign:align, padding:"10px 12px", whiteSpace:"nowrap",
    cursor:"pointer", userSelect:"none",
    borderBottom:"1px solid var(--border)",
    background:"var(--bg3)",
  });

  const tdBase = { padding:"12px 12px", borderBottom:"1px solid var(--border)", verticalAlign:"middle" };

  return (
    <div style={{ padding: isMobile ? "16px 12px" : "24px 28px" }}>

      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <div style={{ fontFamily:FM, fontSize: isMobile?20:26, fontWeight:900, color:"var(--text)", letterSpacing:"-0.01em" }}>
            {mode === "crypto" ? "Crypto Markets" : "Stock Markets"}
          </div>
          <div style={{ fontFamily:FM, fontSize:11, color:"var(--text4)", marginTop:3 }}>
            Top 50 by market cap · updates every {mode==="crypto"?"60s":"2m"}
            {lastUpdate && <span style={{ marginLeft:8, color:"var(--text5)" }}>Last: {lastUpdate.toLocaleTimeString()}</span>}
          </div>
        </div>

        <div style={{ display:"flex", gap:8, alignItems:"center" }}>
          {/* Mode toggle */}
          <div style={{ display:"flex", border:"1px solid var(--border)", borderRadius:8, overflow:"hidden" }}>
            {[
              { id:"crypto", label:"Crypto",  icon:"ph-coin" },
              { id:"stocks", label:"Stocks",  icon:"ph-buildings" },
            ].map(m => (
              <button key={m.id} onClick={() => setMode(m.id)} style={{
                background: mode===m.id ? `${C.orange}18` : "transparent",
                border:"none", padding:"7px 14px", cursor:"pointer",
                fontFamily:FM, fontSize:10, fontWeight:700,
                color: mode===m.id ? C.orange : "var(--text4)",
                display:"flex", alignItems:"center", gap:6, transition:"all 0.15s",
                borderRight: m.id==="crypto" ? "1px solid var(--border)" : "none",
              }}>
                <i className={`ph ${m.icon}`} style={{ fontSize:13 }}/>
                {m.label}
              </button>
            ))}
          </div>

          {/* Search */}
          <div style={{ position:"relative" }}>
            <i className="ph ph-magnifying-glass" style={{ position:"absolute", left:10, top:"50%", transform:"translateY(-50%)", fontSize:13, color:"var(--text4)", pointerEvents:"none" }}/>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..."
              style={{ background:"var(--bg2)", border:"1px solid var(--border)", borderRadius:8, padding:"8px 12px 8px 32px", fontFamily:FM, fontSize:12, color:"var(--text)", outline:"none", width:160 }}
              onFocus={e=>e.currentTarget.style.borderColor=C.orange}
              onBlur={e=>e.currentTarget.style.borderColor="var(--border)"}/>
          </div>
        </div>
      </div>

      {/* Error */}
      {error && (
        <div style={{ background:"rgba(224,62,26,0.08)", border:"1px solid #E03E1A33", borderRadius:10, padding:"12px 16px", marginBottom:16, fontFamily:FM, fontSize:11, color:"#E03E1A" }}>
          ⚠ {error}
          <button onClick={() => mode==="crypto"?fetchCrypto():fetchStocks()} style={{ marginLeft:12, background:"transparent", border:"1px solid #E03E1A", borderRadius:5, padding:"2px 8px", cursor:"pointer", fontFamily:FM, fontSize:9, fontWeight:700, color:"#E03E1A" }}>RETRY</button>
        </div>
      )}

      {/* Loading */}
      {loading && (
        <div style={{ display:"flex", flexDirection:"column", gap:1 }}>
          {Array(10).fill(null).map((_,i) => (
            <div key={i} style={{ height:56, background:"var(--bg2)", borderRadius:i===0?"10px 10px 0 0":i===9?"0 0 10px 10px":0, animation:"pulse 1.2s ease-in-out infinite", borderBottom:"1px solid var(--border)" }}/>
          ))}
        </div>
      )}

      {/* Table */}
      {!loading && (
        <div style={{ background:"var(--bg2)", border:"1px solid var(--border)", borderRadius:12, overflow:"hidden" }}>
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", tableLayout:"auto" }}>
              <thead>
                <tr>
                  <th onClick={()=>handleSort("rank")} style={{...thStyle("rank","center"), width:40}}># <SortIcon k="rank"/></th>
                  <th onClick={()=>handleSort("name")} style={{...thStyle("name","left"), minWidth:180}}>NAME <SortIcon k="name"/></th>
                  <th onClick={()=>handleSort("price")} style={{...thStyle("price"), minWidth:110}}>PRICE <SortIcon k="price"/></th>
                  {!isMobile && <>
                    {mode==="crypto" && <th onClick={()=>handleSort("pct1h")} style={{...thStyle("pct1h"), minWidth:70}}>1H % <SortIcon k="pct1h"/></th>}
                    <th onClick={()=>handleSort("pct24h")} style={{...thStyle("pct24h"), minWidth:70}}>24H % <SortIcon k="pct24h"/></th>
                    {mode==="crypto" && <th onClick={()=>handleSort("pct7d")} style={{...thStyle("pct7d"), minWidth:70}}>7D % <SortIcon k="pct7d"/></th>}
                    <th onClick={()=>handleSort("marketCap")} style={{...thStyle("marketCap"), minWidth:130}}>MARKET CAP <SortIcon k="marketCap"/></th>
                    <th onClick={()=>handleSort("volume")} style={{...thStyle("volume"), minWidth:130}}>VOLUME (24H) <SortIcon k="volume"/></th>
                    {mode==="crypto" && <th style={{...thStyle("supply"), minWidth:140, cursor:"default"}}>CIRCULATING SUPPLY</th>}
                    {mode==="crypto" && <th style={{...thStyle("spark","center"), minWidth:90, cursor:"default"}}>7D CHART</th>}
                  </>}
                </tr>
              </thead>
              <tbody>
                {filtered.map(row => (
                  <tr key={row.id}
                    onClick={() => onSelectTicker && onSelectTicker({ symbol: row.symbol, name: row.name, mode })}
                    onMouseEnter={e=>{ Array.from(e.currentTarget.cells).forEach(c=>c.style.background="rgba(255,255,255,0.02)"); e.currentTarget.style.cursor = onSelectTicker ? "pointer" : "default"; }}
                    onMouseLeave={e=>Array.from(e.currentTarget.cells).forEach(c=>c.style.background="transparent")}>

                    {/* Rank */}
                    <td style={{...tdBase, textAlign:"center"}}>
                      <span style={{ fontFamily:FM, fontSize:12, fontWeight:700, color:"var(--text4)" }}>{row.rank}</span>
                    </td>

                    {/* Name */}
                    <td style={tdBase}>
                      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                        <img src={row.logo} alt={row.symbol} width={28} height={28}
                          style={{ borderRadius:"50%", flexShrink:0, background:"var(--bg3)" }}
                          onError={e => { e.target.style.display="none"; }}/>
                        <div>
                          <div style={{ fontFamily:FM, fontSize:13, fontWeight:900, color:"var(--text)" }}>{row.name}</div>
                          <div style={{ fontFamily:FM, fontSize:9, fontWeight:700, color:"var(--text4)", letterSpacing:"0.1em" }}>{row.symbol}</div>
                        </div>
                      </div>
                    </td>

                    {/* Price */}
                    <td style={{...tdBase, textAlign:"right"}}>
                      <span style={{ fontFamily:FM, fontSize:13, fontWeight:700, color:"var(--text)" }}>{fmtPrice(row.price)}</span>
                    </td>

                    {!isMobile && <>
                      {mode==="crypto" && <td style={{...tdBase,textAlign:"right"}}><PctCell v={row.pct1h}/></td>}
                      <td style={{...tdBase,textAlign:"right"}}><PctCell v={row.pct24h}/></td>
                      {mode==="crypto" && <td style={{...tdBase,textAlign:"right"}}><PctCell v={row.pct7d}/></td>}

                      {/* Market cap */}
                      <td style={{...tdBase,textAlign:"right"}}>
                        <span style={{ fontFamily:FM, fontSize:12, fontWeight:700, color:"var(--text)" }}>{fmtLarge(row.marketCap)}</span>
                      </td>

                      {/* Volume */}
                      <td style={{...tdBase,textAlign:"right"}}>
                        <div style={{ fontFamily:FM, fontSize:12, fontWeight:700, color:"var(--text)" }}>{fmtLarge(row.volume)}</div>
                        {row.marketCap > 0 && row.volume > 0 && (
                          <div style={{ fontFamily:FM, fontSize:9, color:"var(--text5)", marginTop:1 }}>
                            {((row.volume/row.marketCap)*100).toFixed(1)}% of mcap
                          </div>
                        )}
                      </td>

                      {/* Supply (crypto only) */}
                      {mode==="crypto" && (
                        <td style={{...tdBase,textAlign:"right"}}>
                          <div style={{ fontFamily:FM, fontSize:12, fontWeight:700, color:"var(--text)" }}>{fmtSupply(row.supply, row.symbol)}</div>
                          {row.maxSupply && (
                            <div style={{ marginTop:4 }}>
                              <div style={{ width:"100%", height:2, background:"var(--border)", borderRadius:1 }}>
                                <div style={{ height:"100%", borderRadius:1, width:`${Math.min(100,(row.supply/row.maxSupply)*100)}%`, background:C.orange }}/>
                              </div>
                            </div>
                          )}
                        </td>
                      )}

                      {/* Sparkline (crypto only) */}
                      {mode==="crypto" && (
                        <td style={{...tdBase,textAlign:"center"}}>
                          <Sparkline data={row.spark} positive={row.pct7d >= 0}/>
                        </td>
                      )}
                    </>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div style={{ padding:"10px 16px", borderTop:"1px solid var(--border)", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <div style={{ fontFamily:FM, fontSize:9, color:"var(--text5)", letterSpacing:"0.1em" }}>
              {filtered.length} OF {activeData.length} · {mode==="crypto" ? "DATA BY COINGECKO" : "DATA BY YAHOO FINANCE"}
            </div>
            <button onClick={()=>mode==="crypto"?fetchCrypto():fetchStocks()} style={{
              background:"transparent", border:"1px solid var(--border)", borderRadius:6,
              padding:"4px 10px", cursor:"pointer", fontFamily:FM, fontSize:9, fontWeight:700,
              color:"var(--text4)", display:"flex", alignItems:"center", gap:5,
            }}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=C.orange;e.currentTarget.style.color=C.orange;}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--border)";e.currentTarget.style.color="var(--text4)";}}>
              <i className="ph ph-arrows-clockwise" style={{ fontSize:11 }}/>
              REFRESH
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Ticker Detail Page with TradingView chart ─────────────────────────────────
export function MarketTickerDetail({ symbol, name, mode, onBack, isMobile = false }) {
  const containerRef = useRef(null);

  const tvSymbol = mode === "crypto"
    ? `CRYPTO:${symbol.replace("-USDT","").replace("-USD","")}USD`
    : symbol;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.innerHTML = "";
    const widgetDiv = document.createElement("div");
    widgetDiv.className = "tradingview-widget-container__widget";
    widgetDiv.style.width = "100%";
    widgetDiv.style.height = "100%";
    container.appendChild(widgetDiv);
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize:false, width:"100%", height:600,
      symbol:tvSymbol, interval:"D", timezone:"Etc/UTC",
      theme:"dark", style:"1", locale:"en",
      backgroundColor:"rgba(0,0,0,0)",
      gridColor:"rgba(44,44,44,0.5)",
      hide_top_toolbar:false, hide_legend:false,
      save_image:false, allow_symbol_change:true,
      support_host:"https://www.tradingview.com",
    });
    container.appendChild(script);
    return () => { container.innerHTML = ""; };
  }, [tvSymbol]);

  return (
    <div style={{ padding: isMobile ? "16px 12px" : "24px 28px" }}>
      <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:24 }}>
        <button onClick={onBack} style={{
          background:"var(--bg2)", border:"1px solid var(--border)",
          borderRadius:8, width:36, height:36,
          display:"flex", alignItems:"center", justifyContent:"center",
          cursor:"pointer", color:"var(--text4)", transition:"all 0.15s",
        }}
          onMouseEnter={e=>{e.currentTarget.style.borderColor=C.orange;e.currentTarget.style.color=C.orange;}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="var(--border)";e.currentTarget.style.color="var(--text4)";}}>
          <i className="ph ph-arrow-left" style={{ fontSize:16 }}/>
        </button>
        <div>
          <div style={{ display:"flex", alignItems:"baseline", gap:10 }}>
            <span style={{ fontFamily:FM, fontSize:isMobile?20:26, fontWeight:900, color:"var(--text)" }}>{symbol}</span>
            <span style={{ fontFamily:FM, fontSize:14, fontWeight:400, color:"var(--text4)" }}>{name}</span>
          </div>
          <div style={{ fontFamily:FM, fontSize:10, color:"var(--text5)", marginTop:2, letterSpacing:"0.05em" }}>
            {mode === "crypto" ? "CRYPTO" : "STOCK"} · TRADINGVIEW CHART
          </div>
        </div>
      </div>
      <div style={{ background:"var(--bg2)", border:"1px solid var(--border)", borderRadius:12, overflow:"hidden" }}>
        <div ref={containerRef} className="tradingview-widget-container" style={{ height:600, width:"100%" }}/>
      </div>
    </div>
  );
}
